import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CommonService from '../../services/commonService';

const getSeatIcon = seat => {
  if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.number &&
    !seat.isSelected &&
    seat.number &&
    (seat.type.toUpperCase().indexOf('EJECUTIVO') > -1 ||
      seat.type.toUpperCase().indexOf('CLASICO') > -1)
  ) {
    return 'icon-executive-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.number &&
    (seat.type.toUpperCase().indexOf('EJECUTIVO') > -1 ||
      seat.type.toUpperCase().indexOf('CLASICO') > -1)
  ) {
    return 'icon-executive-seat_selected';
  } else if (
    !seat.isGangWay &&
    !seat.isReservable &&
    seat.number &&
    (seat.type.toUpperCase().indexOf('EJECUTIVO') > -1 ||
      seat.type.toUpperCase().indexOf('CLASICO') > -1)
  ) {
    return 'icon-executive-seat_occupied';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    !seat.isSelected &&
    seat.type.toUpperCase() == 'PREMIUM'
  ) {
    return 'icon-vip-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.type.toUpperCase() == 'PREMIUM'
  ) {
    return 'icon-vip-seat_selected';
  } else if (!seat.isGangWay && !seat.isReservable && seat.type.toUpperCase() == 'PREMIUM') {
    return 'icon-vip-seat_occupied';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    !seat.isSelected &&
    seat.type.toUpperCase().indexOf('PREFERENTE') > -1
  ) {
    return 'icon-vip-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.type.toUpperCase().indexOf('PREFERENTE') > -1
  ) {
    return 'icon-vip-seat_selected';
  } else if (
    !seat.isGangWay &&
    !seat.isReservable &&
    seat.type.toUpperCase().indexOf('PREFERENTE') > -1
  ) {
    return 'icon-vip-seat_occupied';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    !seat.isSelected &&
    (seat.type.toUpperCase().indexOf('SALON CAMA') > -1 ||
      seat.type.toUpperCase().indexOf('SALON SIN VENT') > -1)
  ) {
    return 'icon-salon-cama-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    (seat.type.toUpperCase().indexOf('SALON CAMA') > -1 ||
      seat.type.toUpperCase().indexOf('SALON SIN VENT') > -1)
  ) {
    return 'icon-salon-cama-seat_selected';
  } else if (
    !seat.isGangWay &&
    !seat.isReservable &&
    (seat.type.toUpperCase().indexOf('SALON CAMA') > -1 ||
      seat.type.toUpperCase().indexOf('SALON SIN VENT') > -1)
  ) {
    return 'icon-salon-cama-seat_occupied';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    !seat.isSelected &&
    seat.type.toUpperCase().indexOf('SEMI CAMA') > -1
  ) {
    return 'icon-semi-bed-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.type.toUpperCase().indexOf('SEMI CAMA') > -1
  ) {
    return 'icon-semi-bed-seat_selected';
  } else if (
    !seat.isGangWay &&
    !seat.isReservable &&
    seat.type.toUpperCase().indexOf('SEMI CAMA') > -1
  ) {
    return 'icon-semi-bed-seat_occupied';
  } else if (seat.number == 'DR_IMG') {
    return 'icon-steering';
  }
};

const getSeatTypeName = seat => {
  if (!seat.isGangWay && seat.isReservable && seat.number && !seat.isSelected && seat.number) {
    return 'available';
  } else if (!seat.isGangWay && seat.isReservable && seat.isSelected && seat.number) {
    return 'selected';
  } else if (!seat.isGangWay && !seat.isReservable && seat.number) {
    return 'occupied';
  }
};

export default class TrainCoachLayout extends Component {
  static propTypes = {
    selectedService: PropTypes.object,

    metaData: PropTypes.object,
    coachLayout: PropTypes.array,
    upperAvalibility: PropTypes.bool,
    selectedSeatsToBook: PropTypes.array,
    onFloorChange: PropTypes.func,
    selectedFloor: PropTypes.any,
    onSeatSelect: PropTypes.func,
    t: PropTypes.func,
    serviceDetails: PropTypes.object
  };

  seatMouseoverDivEl = [];
  constructor(props) {
    super(props);

    this.state = {
      coachLowerLimit: 0,
      coachUpperLimit: 16,
      marginLeft: 0,
    };
  }

  seatRow = seatDir => {
    let rows = this.props.coachLayout[this.props.selectedFloor].map((row, i) => (
      <ul key={i + Math.random()}>{this.seatCol(row, seatDir)}</ul>
    ));
    return rows;
  };

  renderEmptyRow = () => {
    <li key={10 + Math.random()} className="gw"></li>;
  };

  seatCol = (row, seatDir) => {
    let cols = row.map((seat, i) => {
      return !(
        seat.isGangWay ||
        seat.isBreak ||
        (seat.number && (seat.number.indexOf('GY') > -1 || seat.number.indexOf('gy') > -1))
      ) && seat.object.floor_no === this.props.selectedFloor ? (
        this.seatItem(seat, i)
      ) : (
        <li key={i + Math.random()} className="gw">
          {' '}
        </li>
      );
    });
    return cols;
  };

  seatItem = (seat, i) => {
    return seat.number ? (
      <li
        rowSpan={seat.rowSpan}
        colSpan={seat.colSpan}
        className={
          getSeatTypeName(seat) +
          ' ' +
          getSeatIcon(seat).split('_')[0] +
          ' ' +
          (seat.object.seat_direction == 2 ? 'seat-reverse-dir' : 'seat-normal-dir')
        }
        key={i + Math.random()}
        onClick={() => {
          this.props.onSeatSelect(
            CommonService.selectSeat(
              seat,
              this.props.metaData,
              this.props.coachLayout[this.props.selectedFloor],
              this.props.selectedSeatsToBook,
              this.props.selectedService && this.props.selectedService.route,
            ),
          );
        }}
        onMouseEnter={ev => this.seatMouseEnter(ev, seat)}
        onMouseLeave={this.seatMouseLeave}
      >
        {/* <img src={getSeatIcon(seat)}/> */}

        {getSeatIcon(seat) != 'icon-steering' ? (
          <span className="seat-number bold-text">
            {seat.number != 'DR_IMG' ? seat.number : ''}
          </span>
        ) : null}
        {getSeatIcon(seat) != 'icon-steering' ? (
          <div className={'seat-sprite ' + getSeatIcon(seat)}></div>
        ) : null}
      </li>
    ) : null;
  };

  seatMouseEnter = (ev, seat) => {
    let pos = ev.target.getClientRects();
    this.setState({
      seat: seat,
      mouseOverPos: pos[0],
      seatMouseOverClass: 'onmouseover',
    });
  };

  seatMouseLeave = () => {
    this.setState({ seat: null, mouseOverPos: null, seatMouseOverClass: '' });
  };

  onFloorChange = floor => {
    this.props.onFloorChange(floor);
    setTimeout(() => {
      this.setState({});
    }, 250);
  };

  getTabs = () => {
    let tabs = [];
    for (let i = 0; i < this.props.coachLayout.length; i++) {
      tabs.push(
        <a
          key={i}
          className={this.props.selectedFloor === i ? 'active bold-text' : ''}
          // onClick={() => {this.onFloorChange('lower')}}
          onClick={() => {
            this.onFloorChange(i);
            this.setState({ marginLeft: 0});
          }}
        >
          {this.props.t('RESULTS_PAGE.WAGON') + ' #' + (i + 1)}
        </a>,
      );
    }
    return tabs;
  };

  increaseWagon = floor => {
    console.log('Floooooorrrrr ------------', floor);
    if (this.state.marginLeft > -500 && floor == 0)
      this.setState({ marginLeft: this.state.marginLeft - 100 });
    else if (floor == 1 && this.state.marginLeft > -700)
      this.setState({ marginLeft: this.state.marginLeft - 100 });
    else if (floor == 2 && this.state.marginLeft > -100)
      this.setState({ marginLeft: this.state.marginLeft - 100 });
    // if(this.props.selectedFloor < 2) this.onFloorChange(this.props.selectedFloor+1);
  };

  decreaseWagon = floor => {
    if (this.state.marginLeft < 0 && floor == 0)
      this.setState({ marginLeft: this.state.marginLeft + 100 });
    else if (this.state.marginLeft < 0 && this.state.marginLeft < 500 && floor > 0)
      this.setState({ marginLeft: this.state.marginLeft + 100 });
    // if(this.props.selectedFloor > 0) this.onFloorChange(this.props.selectedFloor-1);
  };

  getSeatName = rawSeat => {
    console.log('Raw seat'.rawSeat);
    switch (rawSeat) {
      case 'SALON CAMA':
        return 'Salón Cama';
        break;
      case 'CLASICO':
        return 'Clásico';
        break;
      case 'Clasico':
        return 'Clásico';
        break;
      case 'Salon Sin Vent':
        return 'Salón Sin Vent';
        break;
      case 'SALON SIN VENT':
        return 'Salón Sin Vent';
        break;
      case 'Salon Preferente':
        return 'Salón Preferente';
        break;
      case 'SALON PREFERENTE':
        return 'Salón Preferente';
        break;
      case 'SALON':
        return 'Salón ';
        break;
      case 'Salon':
        return 'Salón ';
        break;
      default:
        return CommonService.capitalize(rawSeat);
        break;
    }
  };

  renderMouseOver = () => {
    return (
      <div
        className={'seat-mousover mouseover-popups font9 nowrap ' + this.state.seatMouseOverClass}
        // key={this.state.seat.object.number}
        style={{
          position: 'fixed',
          left: this.state.mouseOverPos ? this.state.mouseOverPos.x : null,
          top: this.state.mouseOverPos ? this.state.mouseOverPos.y : null,
        }}
      >
        <div>
          {this.props.t('CANCEL_TICKET.SEAT_NUMBER')}:{' '}
          {this.state.seat ? this.state.seat.object.number : null}
        </div>
        <div>
          {this.props.t('CANCEL_TICKET.FARE')}: CLP{' '}
          {this.state.seat
            ? CommonService.currency(this.state.seat.object.net_amount).split(',')[0]
            : null}
        </div>
        <div>
          {this.props.t('RESULTS_PAGE.SEAT_TYPE')}:{' '}
          {this.state.seat
            ? CommonService.capitalize(this.getSeatName(this.state.seat.object.type))
            : null}
        </div>
        <span className="primary-triangle"></span>
      </div>
    );
  };

  render() {
    let { t, serviceDetails } = this.props;
    return (
      <div className="pb-service-list-coach-layout pb-service-list-train-coach-layout">
        <div className="flex-row floor-buttons-row ">
          <div className="font10">
            {CommonService.isTrain() || serviceDetails.travel_id == 272 ? (
              this.props.coachLayout && this.props.coachLayout.length > 1 ? (
                <div className="floor-buttons white-text flex-row ">{this.getTabs()}</div>
              ) : null
            ) : null}
          </div>
          <div className="flex-row legends-row font10">
            <div className="flex-row legend">
              <div className="legend-color available"></div>
              <div className="legend-label dark-text">{t('RESULTS_PAGE.SEAT_AVAILABLE')}</div>
            </div>
            <div className="flex-row legend">
              <div className="legend-color selected"></div>
              <div className="legend-label dark-text">{t('RESULTS_PAGE.SEAT_SELECTED')}</div>
            </div>
            <div className="flex-row legend">
              <div className="legend-color reserved"></div>
              <div className="legend-label dark-text">{t('RESULTS_PAGE.SEAT_OCCUPIED')}</div>
            </div>
          </div>
        </div>

        <div
          onMouseLeave={this.seatMouseLeave}
          className={'  seats-in-coach .train' + this.props.selectedFloor}
        >
          <div className="coach-layout-container train-coach-layout kupos-border">
            <div>
              <div className="driver rotate-x-180">
                <div className="coach-layout-front-text font8">
                  <span className="webkit-text-rotate-180">
                    {t('RESULTS_PAGE.TRAIN_FRONT_MESSAGE')}
                  </span>
                  <img className="front-text-image" src="/static/images/arrow_train_left_direction.svg" />
                </div>
              </div>
              {/* {this.props.selectedFloor == 'lower' || !this.props.upperAvalibility ? (
            <div className="driver">
              <img src="/static/images/seats/icon-steering.png" />
              <div className="top-line"></div>
              <div className="bottom-line"></div>
            </div>
          ) : null} */}
              <div
                style={{ marginLeft: this.state.marginLeft }}
                className={
                  'coach-table light-text ' +
                  (this.props.upperAvalibility ? '' : 'optimize-seat-spacing')
                }
              >
                {this.props.coachLayout[this.props.selectedFloor] &&
                this.props.coachLayout[this.props.selectedFloor].length
                  ? this.seatRow(1)
                  : null}
                {/* <div className="seats-dir-gap"></div> */}
                {/* {this.props.coachLayout[this.props.selectedFloor] && this.props.coachLayout[this.props.selectedFloor].length ? this.seatRow(2) : null} */}
              </div>
            </div>

            <div className="coach-layout-bottom-text-container display-flex">
              <img
                onClick={() => this.decreaseWagon(this.props.selectedFloor)}
                src="/static/images/left_multiple_arrows.svg"
              />
              <span className="font9">{t('RESULTS_PAGE.TRAIN_BOTTOM_MESSAGE').toUpperCase()}</span>
              <img
                onClick={() => this.increaseWagon(this.props.selectedFloor)}
                src="/static/images/right_multiple_arrows.svg"
              />
            </div>
          </div>
        </div>
        {this.state.seat ? this.renderMouseOver() : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/pb-service-list/TrainCoachLayout.js